






























import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbTransferOrder } from '@/http';
import { padHeadPanel2 } from "@/components";
import outallot from "./components/outallot.vue";
import inallot from "./components/inallot.vue";
@Component({
    components: {
        padHeadPanel2,outallot,inallot
    },
})
export default class allot extends Vue {

    active='dbck';
    //调拨入库数量
    innum = null;

    userInfo = {}

    public $refs: {
    };
    async created() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
        let obj = {
            outShopId:'',
            transferStatus:null,
            start:'',
            end:'',
            skip:0,
            count:-1,
            receiveShopId:this.userInfo['shopId']
        }
        let res = await TbTransferOrder.GetTbTransferOrderListV2(obj);
        this.innum = res.items.filter(v=>v.transferStatus==1).length;
        console.log('res最初this.innum',this.innum);
        let allotactive = localStorage.getItem("allotactive")
            ? localStorage.getItem("allotactive")
            : 1;
        if (Number(allotactive)==1) {
            this.active = 'dbck'
            console.log("allotactive", allotactive);
            localStorage.removeItem('allotactive');
        }else if(Number(allotactive)==2){
            this.active = 'dbrk'
            console.log("allotactive", allotactive);
            localStorage.removeItem('allotactive');
        }
    }
    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }

   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/allot/allot.vue